import { render, staticRenderFns } from "./platapply-approval-gr.vue?vue&type=template&id=032525aa&"
import script from "./platapply-approval-gr.vue?vue&type=script&lang=js&"
export * from "./platapply-approval-gr.vue?vue&type=script&lang=js&"
import style0 from "./platapply-approval-gr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports